import type { ReactNode } from 'react';
import { Box } from '@chakra-ui/react';
import { CanvasView, drawIcon, useLegacyIcon } from '@casa/tiles';

/** An icon by its legacy or Font Awesome name, drawn in a square. */
export function IconGlyph({ name, size = 28, color = '#ffffff' }: { name: string | undefined; size?: number; color?: string }) : ReactNode {
    const icon = useLegacyIcon(name);

    return (
        <Box width={`${size}px`} height={`${size}px`} flex="none">
            <CanvasView deps={[icon, color]} draw={(ctx, width, height) => icon && drawIcon(ctx, icon, { left: 0, top: 0, width, height }, color)} />
        </Box>
    );
}
